import React from "react";

import {
    Button,
    Card,  CardHeader,  CardBody,  CardTitle,
    Row,  Col,
    FormGroup,
    Modal, ModalBody,ModalFooter
  } from "reactstrap";

import ReactTable from "react-table-legacy";
import { Link } from 'react-router-dom';

import Request from '../../common/Request';

import InputText from '../FormParts/InputText';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip'
import Definition from '../../common/Definition';
import WithRole from '../FormParts/ButtonWithRole';

export default class AdminCustomerSelectPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            data: [],
            column: this.default_column,
            selectionChanged:"",
            selectionBranchChanged:"",
            customer_id: "",
            customer_branch_id: "",
            customer_name: "",
            customer_branch_name:"",
            customer_branch_tel: "",
            customer_user_name: "",
            customer_user_tel: "",
            customer_data: [],
            customer_branch_data: [],
            customer_user_data: [],
            customer_table:"off",
            branchBox: "off",
            userBox: "off",
            selected: null,
            tmp_cnt: "5",
            column:[{ Header: '会社名', accessor: 'customer_name', headerClassName: "text-left", className: "text-left text-top",minWidth:240 },
                    { Header: '会社ID', accessor: 'customer_id', show:false },
                    { Header: '', accessor: 'action', headerClassName: "text-center", className: "text-center" ,width:60, minWidth:60, sortable : false},
                    { Header: '', accessor: 'symbol', headerClassName:'text-center', className:'text-center',width:30, minWidth:30, sortable : false}],
            column_branch:[
                    { Header: '会社ID', accessor: 'customer_id', show:false },
                    { Header: '支店ID', accessor: 'customer_branch_id',show:false},
                    { Header: '支店名', accessor: 'customer_branch_name', headerClassName: "text-left ", className: "text-left text-top",minWidth:160  },
                    { Header: 'TEL', accessor: 'customer_branch_tel', headerClassName: "text-left ", className: "text-left text-top ",minWidth:80  },
                    { Header: '', accessor: 'action', headerClassName: "text-center", className: "text-center" ,width:60, minWidth:60, sortable : false},
                    { Header: '', accessor: 'symbol', headerClassName:'text-center', className:'text-center',width:30, minWidth:30, sortable : false}
                ],
            column_user:[
                    { Header: '担当者名', accessor: 'customer_user_name', headerClassName: "text-left ", className: "text-left text-top",minWidth:160  },
                    { Header: '連絡先', accessor: '__JOIN_customer_user_contact_information', headerClassName: "text-left ", className: "text-left text-top",width:100 },
                    // { Header: '', accessor: 'action_link', headerClassName: "text-center", className: "text-center", width:0, sortable : false},
                    { Header: 'アクション', accessor: 'action', headerClassName: "text-center", className: "text-center",width:70, minWidth:70 , sortable : false},
                    ],
            defaultPageSize: 300
        };
        this.setTmp = this.setTmp.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.search = this.search.bind(this);
        this.validate_customer_customer_name = this.validate_customer_customer_name.bind(this);
        this.clickSelectButton = this.clickSelectButton.bind(this);
        this.linkButton = this.linkButton.bind(this)
        this.requestData = this.requestData.bind(this)
        this.validateCallback = this.validateCallback.bind(this)
    }

    componentDidMount(){
      this.search("customer",this.props.customerId,"")
    }

    componentDidUpdate(prevProps, prevState){
      if(prevProps.customerId != this.props.customerId ||
        prevProps.customerBranchId != this.props.customerBranchId) {
          if(this.props.customerId) {
            this.search("customer",this.props.customerId,"")
            if(this.props.customerBranchId) {
              this.search("customer/branch",this.props.customerId,this.props.customerBranchId)
              this.search("customer/user",this.props.customerId,this.props.customerBranchId)
            }
          }
      }
    }

    symbol(value){
      return <span style={{color:"#344675", fontSize:"30px", weight:"500", marginLeft:"-10px", display: "block", height: "30px", marginTop: "-28px"}} dangerouslySetInnerHTML={{__html:value}}></span>
    }

    validate_customer_customer_name(valid, text) {
        this.setState({ customer_customer_name_valid: valid, customer_customer_name: text }, () => { valid && this.search(); });
    }
    linkButton(label, toUrl, button_id, prop){
      const LinkWithRole = WithRole(Link, this.props.buttons, prop)
      return <LinkWithRole className="btn btn-secondary small-btn" target="_blank" to={toUrl}>
        <span style={{color:"white", textDecoration:"none"}}>{label}</span>
      </LinkWithRole>
    }

    dataMap(data) {
        return data.map((prop, key) => {
          
          return {
            customer_name: prop.customer_name,
            customer_name_view: prop.customer_name,
            customer_id:prop.ulid,
            action: this.linkButton('詳細', "/customer/detail/"+prop.ulid, (this.props.view?"BTN_A1_04_00990":"BTN_A1_02_00610"),prop),
            symbol: this.symbol("&#x27AD;")
          }
        });
      }
      dataBranchMap(data){
        return data.map((prop, key) => {
          return {
            customer_branch_name: prop.customer_branch_name,
            customer_branch_name_view: prop.customer_branch_name,
            customer_branch_id:prop.ulid,
            customer_branch_tel:prop.customer_branch_tel,
            action: this.linkButton('詳細', "/customer/detail/branch/"+prop.ulid, undefined, prop),
            symbol: this.symbol("&#x27AD;")
          }
        });
      }
      dataUserMap(data){
        return data.map((prop, key) => {
          return {
            customer_user_name: prop.customer_user_name,
            __JOIN_customer_user_contact_information: <div dangerouslySetInnerHTML={{__html:Definition.item('__JOIN_customer_user_contact_information', prop)}} />,
            action: (
              <Button 
                type="button" 
                color="default" 
                className="small-btn" 
                onClick={(e) => { 
                  e.stopPropagation();
                  this.clickSelectButton(prop, "customer_user"); 
                }}>選択
                </Button>
            )
          }
        });
      }
      setTmp(){
        if (this.state.tmp_set === "off") {
            this.setState({tmp_set:'on'});
        } else{
            this.setState({tmp_set:'off'});
        }
      }  
  // 検索
  search(name,customer_id,customer_branch_id) {
    /* ここは開発者が記述 */
    var domain = "";
    var url = domain + '/api/'+name;
    let params = {};

    switch(name){
      case "customer":
        
        this.setState({
        customer_table: 'on',
        branchBox:'off',
        userBox:'off'
        });
        if(customer_id != ""){
          params.ulid = customer_id;
        }
      break;
      case "customer/branch":
          if(customer_id == ""){
            return false;
          }
          this.setState({
            branchBox:'on',
            userBox:'off',
            customer_id:customer_id
          });
          params.customer_ulid = customer_id;
          params.show_delete_data = 0

          if(customer_branch_id != "") {
            params.customer_branch_ulid = customer_branch_id;
          }
          if(this.state.customer_branch_name != ""){
            params.customer_branch_name = this.state.customer_branch_name;
          }
          if(this.state.customer_branch_tel != ""){
            params.customer_branch_tel = this.state.customer_branch_tel;
          }
          break;
      case "customer/user":
          if(customer_branch_id == ""){
            return false;
          }
          this.setState({branchBox:'on',
                         userBox:'on',
                         customer_branch_id:customer_branch_id,
                         customer_id,customer_id});
          params = {
            customer_branch_ulid: customer_branch_id,
            customer_user_name: this.state.customer_user_name?this.state.customer_user_name:undefined,
            customer_user_tel: this.state.customer_user_tel?this.state.customer_user_tel:undefined,
            show_delete_data:0
          }
        break;

    }
    this.requestData(url, params, name)
  }

  requestData(url, params, name, callback=()=>{}){
    Request.get(url, params, res => {
      switch(name){
        case "customer":
            this.setState({
              customer_data: this.dataMap(res.data)
            }, ()=>callback());
        break;
        case "customer/branch":
            this.setState({
              customer_branch_data: this.dataBranchMap(res.data)
            }, ()=>callback());
        break;
        case "customer/user":
            this.setState({
              customer_user_data:this.dataUserMap( res.data)
            }, ()=>callback());
        break;
      }
    })
  }

    clickSelectButton(prop, target) {

      // システム管理者はメール必須
      if(!prop.customer_user_email){
        this.props.alertModal.current.showErrorModal({messageNo:2504});
        return;
      }

      if (this.props.customerSelectedCallback) {
          this.props.customerSelectedCallback({
            ...prop,
            [`${target}_id`] : prop.id
          });
      }
      this.toggleModal();
    }

    show() {
        this.setState({ modal: true });
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }
    validateCallback(newData, callback=()=>{}){
      
      this.setState({
        ...this.state,
        ...newData.values
      }, ()=>{callback()})
    }

    render() {
      const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
        return (
            <Modal className="modal-100" isOpen={this.state.modal}>
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
                  <i className="tim-icons icon-simple-remove"></i>
                </button>
                <h5 className="modal-title">{"　"}</h5>
              </div>
                <ModalBody>
                <Row className="tables-tab">
                <Col xl="4" lg="6" md="6" sm="6" id="customer">
                  <Card className="card-border">
                    <CardHeader className="sub">
                      <CardTitle tag="h5" className="float-left">会社一覧</CardTitle>
                    </CardHeader>                
                    <CardBody className="sub">
                      <FormGroup>
                        <Row>
                          <Col lg="8" md="8" sm="12">
                            <InputText
                              label='会社名'
                              name='CUSTOMER__customer_name'
                              labelOn={true}
                              validateCallback={this.validateCallback}
                              enterCallback={(e) => this.search("customer","","",e)}
                              enterSearchFlag={true}
                              rootData={this.state}
                              validateType={'search'}
                              disabled={this.props.customerId}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12">
                          {!this.props.customerId && <ButtonWithTooltipWithRole
                            //button_id={(this.props.view?"BTN_A1_04_00980":"BTN_A1_02_00600")}
                            onclick={(e) => this.search("customer","","",e)}
                            class="float-right btn-search btn-facebook"
                            id="tmp"
                            icon="fas fa-search"
                            label="検索"
                            message="顧客を検索"
                            size="sm"
                          />}
                          </Col>
                        </Row><br />
                        ※最大{this.state.defaultPageSize}件まで表示しています。 

                        
                      </FormGroup>
                      <ReactTable
                          data={this.state.customer_data}
                          columns={this.state.column}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='検索してください'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height "+ this.state.customer_table} 
                          getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                              return {
                                onClick: e => {
                                  if(this.props.ignoreCustomerClick) {
                                    // 会社固定　クリック破棄
                                    return;
                                  }
                                  this.search("customer/branch",rowInfo.row.customer_id,"",e);

                                  if (rowInfo.index != this.state.rowEdit) {
                                    this.setState({
                                      rowEdit: rowInfo.index,
                                      selectedRowIndex: rowInfo.original,
                                      rowBranchEdit: null,
                                      selectionChanged: this.state.selectionChanged
                                        ? false
                                        : true
                                    });
                                  } else {
                                    this.setState({
                                      rowEdit: null,
                                      rowBranchEdit: null
                                    });
                                  }
                                },
                                style: {
                                  background:
                                    rowInfo.index === this.state.rowEdit || this.props.ignoreCustomerClick ? "#dff2fd" : "",
                                  color:
                                    rowInfo.index === this.state.rowEdit || this.props.ignoreCustomerClick ? "white" : "black",
                                  cursor:
                                    "pointer"
                                }
                              };
                            } else {
                              return {};
                            }
                          }}
                        />

                    </CardBody>
                  </Card>
                </Col>
                <Col xl="4" lg="6" md="6" sm="6" id="customer_branch" className={`${this.state.branchBox}`}>
                  <Card className="card-border">
                    <CardHeader className="sub">
                      <CardTitle tag="h5" className="float-left">支店一覧</CardTitle> 
                      </CardHeader>
                      <CardBody className="sub">
                        <FormGroup>
                          <Row>
                            <Col lg="8" md="8" sm="12">
                              <InputText
                                label='支店名'
                                name='CUSTOMER_BRANCH__customer_branch_name'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={(e) => this.search("customer/branch",this.state.customer_id,"",e)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                                disabled={this.props.customerBranchId}
                              />
                              <InputText
                                label='支店TEL'
                                name='CUSTOMER_BRANCH__customer_branch_tel'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={(e) => this.search("customer/branch",this.state.customer_id,"",e)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                                disabled={this.props.customerBranchId}
                              />
                            </Col>
                            <Col lg="3" md="3" sm="12">
                            {!this.props.customerBranchId && <ButtonWithTooltipWithRole
                              //button_id={(this.props.view?"BTN_A1_04_01040":"BTN_A1_02_00660")}
                              onclick={(e) => this.search("customer/branch",this.state.customer_id,"",e)}
                              class="float-right btn-search btn-facebook"
                              id="tmp"
                              icon="fas fa-search"
                              label="検索"
                              message="支店を検索"
                              size="sm"
                            /> }
                            </Col>
                          </Row><br />
                          ※最大{this.state.defaultPageSize}件まで表示しています。 


                        </FormGroup>
                        <ReactTable
                          data={this.state.customer_branch_data}
                          columns={this.state.column_branch}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='支店は登録されていません。'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height"}
                          getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                              return {
                                onClick: e => {
                                  if(this.props.ignoreCustomerBranchClick) {
                                    // 支店固定　クリック破棄
                                    return;
                                  }
                                  this.search("customer/user",this.state.customer_id,rowInfo.row.customer_branch_id,e)

                                  if (rowInfo.index != this.state.rowBranchEdit) {
                                    this.setState({
                                      rowBranchEdit: rowInfo.index,
                                      selectedBranchRowIndex: rowInfo.original,
                                      selectionBranchChanged: this.state.selectionBranchChanged
                                        ? false
                                        : true
                                    });
                                  } else {
                                    this.setState({
                                      rowBranchEdit: null
                                    });
                                  }
                                },
                                style: {
                                  background:
                                    rowInfo.index === this.state.rowBranchEdit || this.props.ignoreCustomerBranchClick ? "#dff2fd" : "",
                                  color:
                                    rowInfo.index === this.state.rowBranchEdit || this.props.ignoreCustomerBranchClick ? "white" : "black",
                                  cursor:
                                    "pointer"
                                }
                              };
                            } else {
                              return {};
                            }
                          }}
                        />
                        
                      </CardBody>
                    </Card>
                </Col>
                <Col xl="4" lg="6" md="6" sm="6" id="customer_user" className={`${this.state.userBox}`}>
                  <Card className="card-border">
                      <CardHeader className="sub">
                        <CardTitle tag="h5" className="float-left">担当者</CardTitle>
                      </CardHeader>
                      <CardBody className="sub">
                        <FormGroup>
                          <Row>
                            <Col lg="8" md="8" sm="12">
                              <InputText
                                label='担当者名'
                                name='CUSTOMER_BRANCH__customer_user_name'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={() =>this.search("customer/user",this.state.customer_id,this.state.customer_branch_id)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                              />
                              <InputText
                                label='担当者TEL'
                                name='CUSTOMER_BRANCH__customer_user_tel'
                                labelOn={true}
                                validateCallback={this.validateCallback}
                                enterCallback={() => this.search("customer/user",this.state.customer_id,this.state.customer_branch_id)}
                                enterSearchFlag={true}
                                rootData={this.state}
                                validateType={'search'}
                              />
                            </Col>
                            <Col lg="3" md="3" sm="12">
                            <ButtonWithTooltipWithRole
                              //button_id={(this.props.view?"BTN_A1_04_01100":"BTN_A1_02_00720")}
                              onclick={(e) => this.search("customer/user",this.state.customer_id,this.state.customer_branch_id,e)}
                              class="float-right btn-search btn-facebook"
                              id="tmp"
                              icon="fas fa-search"
                              label="検索"
                              message="担当者を検索"
                              size="sm"
                            />                       
                            </Col>
                          </Row><br />
                          ※最大{this.state.defaultPageSize}件まで表示しています。 

                        </FormGroup>                  
                        <ReactTable
                          data={this.state.customer_user_data}
                          columns={this.state.column_user}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='担当者は登録されていません。'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height"} 
                        />
                      </CardBody>
                    
                  </Card>
                </Col>
                </Row>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }
}
